import React, { Component } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from './Components/LoginPage/Login';
import SideBar from './SideBar/SideBar';
import TicketBooking from './TicketBooking/TicketBooking'
import AirlineMaster from './MasterScreen/AirlineMaster'
import CityMaster from './MasterScreen/CityMaster'
import PartyMaster from './MasterScreen/PartyMaster'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/AirlineMaster" element={<AirlineMaster />} />
          <Route path="/PartyMaster" element={<PartyMaster />} />
          <Route path="/SideBar" element={<SideBar />} />
          <Route path="/CityMaster" element={<CityMaster />} />
          <Route path="/TicketBooking" element={<TicketBooking />} />
          {/* <Route path="/Overview" element={<Overview />} /> */}

        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
